import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns';

import Spinner from '../../components/Spinner/Spinner'
import { getMeetings, reset } from '../../features/meeting/meetingSlice'
import { Row, Card, Col, Button, Nav } from "react-bootstrap";


function Store() {

    return (
        <Fragment>
            <Row>
                
                <Col xl="4">
                    <Card className="text-center">
                        <Card.Header>
                            <Card.Title>Bireysel 1 Aylık Abonelik</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Card.Text  className="h3 bg-white text-dark">
                                ₺229,99/ay
                            </Card.Text>
                            <Card.Text>
                                Bireysel olarak aylık abone olun. Premium özelliklere erişim sağlayın.
                            </Card.Text>
                            <Button as="a" variant="primary" href="https://iyzi.link/AJbqsA" className="mt-3">
                                Satın Al
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl="4">
                    <Card className="text-center">
                        <Card.Header>
                            <Card.Title>Bireysel 6 Aylık Abonelik</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Card.Text  className="h3 bg-white text-dark">
                                ₺199,99/ay
                            </Card.Text>
                            <Card.Text>
                                Bireysel olarak 6 aylık abone olun. Premium özelliklere erişim sağlayın.
                            </Card.Text>
                            <Button as="a" variant="primary" href="https://iyzi.link/AJbqrg" className="mt-3">
                                Satın Al
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl="4">
                    <Card className="text-center">
                        <Card.Header>
                            <Card.Title>Bireysel 12 Aylık Abonelik</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Card.Text  className="h3 bg-white text-dark">
                                ₺169,99/ay
                            </Card.Text>
                            <Card.Text>
                                Bireysel olarak 12 aylık abone olun. Premium özelliklere erişim sağlayın.
                            </Card.Text>
                            <Button as="a" variant="primary" href="https://iyzi.link/AJbqrw" className="mt-3">
                                Satın Al
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>


                <Col xl="4">
                    <Card className="text-center text-white bg-info">
                        <Card.Header>
                            <Card.Title className="text-white">Mikro Ölçekli İşletmeler</Card.Title>
                        </Card.Header>
                        <Card.Body className="bg-white text-dark">
                            <Card.Text  className="h3 bg-white text-dark">
                                ₺2.000,00/ay
                            </Card.Text>
                            <Card.Text>
                                Aylık 20 Saate Kadar Toplantı Özetleme ve Analiz
                            </Card.Text>
                            <Button as="a" variant="primary" href="https://iyzi.link/AJcB3g" className="mt-3">
                                Satın Al
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl="4">
                    <Card className="text-center text-white bg-info">
                        <Card.Header>
                            <Card.Title className="text-white">Küçük Ölçekli İşletmeler</Card.Title>
                        </Card.Header>
                        <Card.Body className="bg-white text-dark">
                            <Card.Text  className="h3 bg-white text-dark">
                                ₺5.000,00/ay
                            </Card.Text>
                            <Card.Text>
                                Aylık 50 Saate Kadar Toplantı Özetleme ve Analiz
                            </Card.Text>
                            <Button as="a" variant="primary" href="https://iyzi.link/AJcB3w" className="mt-3">
                                Satın Al
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl="4">
                    <Card className="text-center text-white bg-info">
                        <Card.Header>
                            <Card.Title className="text-white">Orta Ölçekli İşletmeler</Card.Title>
                        </Card.Header>
                        <Card.Body className="bg-white text-dark">
                            <Card.Text  className="h3 bg-white text-dark">
                                ₺10.000,00/ay
                            </Card.Text>
                            <Card.Text>
                                Aylık 100 Saate Kadar Toplantı Özetleme ve Analiz
                            </Card.Text>
                            <Button as="a" variant="primary" href="https://iyzi.link/AJ8yNA" className="mt-3">
                                Satın Al
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
                
                        
            </Row>
        </Fragment>

    )
    
}

export default Store 